import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';

/**
 * Zdrojové kategórie noviniek s počtom noviniek a kategóriami, do ktorých
 * patria. Prázdne `categories` = nezaradený zdroj, jeho novinky sa
 * nezobrazujú.
 */
export const getNewsSources = createQueryFn(
  QueryNameSpace.getNewsSources,
  async () => {
    const { sources } = await DigiobcanApi.getNewsSources();
    return sources;
  },
);
